import { render, staticRenderFns } from "./PersistanceReportTable.vue?vue&type=template&id=48bba33f&"
import script from "./PersistanceReportTable.vue?vue&type=script&lang=js&"
export * from "./PersistanceReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports